import * as React from "react";
import type { SVGProps } from "react";
const SvgImage2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4FD08F"
      d="M5.333 0A5.334 5.334 0 0 0 0 5.333v13.334A5.334 5.334 0 0 0 5.333 24h13.334A5.334 5.334 0 0 0 24 18.667V5.333A5.334 5.334 0 0 0 18.667 0zm12 4a2.666 2.666 0 1 1 0 5.333 2.666 2.666 0 1 1 0-5.333m-10 6.667c.776.001 1.955 1.209 3.083 3.292.448.824.85 1.732 1.21 2.625.215.533.382.941.457 1.165.364 1.09 1.841 1.244 2.417.251.057-.099.161-.288.333-.541.288-.427.616-.859.959-1.251.856-.981 1.683-1.541 2.208-1.541.532.013 1.353.572 2.208 1.541a13 13 0 0 1 .959 1.25c.092.134.105.197.166.291v.918a2.666 2.666 0 0 1-2.666 2.666H5.333a2.666 2.666 0 0 1-2.666-2.666V17.54c.084-.237.196-.518.374-.957.364-.893.759-1.8 1.21-2.625 1.137-2.087 2.308-3.294 3.082-3.292"
    />
  </svg>
);
export default SvgImage2;
